import React from 'react'
import styles from '../AccountInfoBar.module.less'

export interface InfoDetailProps {
  label: string
  children: React.ReactNode
}

const InfoDetail: React.FunctionComponent<InfoDetailProps> = ({
  label,
  children,
}) => {
  return (
    <div className={`${styles.infoDetail} info-detail`}>
      <div className={`${styles.infoDetailLabel} info-detail-label`}>
        {label}
      </div>
      <div className={'info-detail-value'}>
        {children}
      </div>
    </div>
  )
}

export default InfoDetail
